import Quill from 'quill';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Block: any = Quill.import('blots/block');

export type CalloutVariant = 'info' | 'tip' | 'warning' | 'success';

export class CalloutBlot extends Block {
  static blotName = 'callout';
  static tagName = 'DIV';
  static className = 'ql-callout';

  static create(value: CalloutVariant | string): HTMLElement {
    const node = super.create(value) as HTMLElement;
    const variant = (value || 'info') as CalloutVariant;
    node.setAttribute('data-callout', variant);
    node.classList.add(`ql-callout--${variant}`);
    return node;
  }

  static formats(node: HTMLElement): string {
    return node.getAttribute('data-callout') || 'info';
  }

  format(name: string, value: unknown): void {
    if (name === CalloutBlot.blotName) {
      const el = this.domNode as HTMLElement;
      if (value) {
        const variant = String(value);
        el.setAttribute('data-callout', variant);
        el.className = `ql-callout ql-callout--${variant}`;
      } else {
        super.format(name, false);
      }
      return;
    }
    super.format(name, value);
  }
}
